import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAdXN4kUhasiZVrI0V6w2BjMwQEbIeWScI",
  authDomain: "cakified-app.firebaseapp.com",
  projectId: "cakified-app",
  storageBucket: "cakified-app.firebasestorage.app",
  messagingSenderId: "64323940904",
  appId: "1:64323940904:web:6a59ace2963c295ba27b1d",
  measurementId: "G-TS7LWFMT7J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage (for images)
export const storage = getStorage(app);

export default app;